import apiClient from "./http";

export const getLatestAnalysis = (projectId) =>
  apiClient.get(`/Analysis/latest/${projectId}`);

export const runAnalysis = (payload) => apiClient.post("/Analysis/run", payload);

export const getAnalysis = (id) => apiClient.get(`/Analysis/${id}`);
